import React, { useEffect, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { Spinner } from './ui-component/spinner/index';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import axios from 'axios';
import errorResponseHandler from './utils/errorResponseHandler';
import { ACCESS_TOKEN, AUTH, MESSAGE, USER_SESSION } from './assets/constants';
import { useAlert } from './context/AlertContext';
import { useNavigate } from 'react-router-dom';
import { MENU_OPEN, SET_AUTHENTICATED, SET_TOKEN, SET_USER_DATA } from './store/actions';

// apply interceptor on response
axios.interceptors.response.use((response) => response, errorResponseHandler);

const App = () => {
    const customization = useSelector((state) => state.customization);
    const { showAlert } = useAlert();
    const themeMemo = useMemo(() => themes(customization), [customization]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const handleLogout = () => {
            console.log('🚪 Ejecutando logout real');

            dispatch({ type: SET_TOKEN, token: '' });
            dispatch({ type: SET_USER_DATA, userData: {} });
            dispatch({ type: SET_AUTHENTICATED, autenticated: false });
            dispatch({ type: MENU_OPEN, id: 'default' });

            localStorage.removeItem(ACCESS_TOKEN);
            localStorage.removeItem(USER_SESSION);
            localStorage.setItem(AUTH, '0');

            //clearAssignedMachine();

            navigate('/auth/login');
        };

        window.addEventListener('session-expired', handleLogout);

        return () => {
            window.removeEventListener('session-expired', handleLogout);
        };
    }, []);

    useEffect(() => {
        var item = localStorage.getItem(MESSAGE);
        if (item !== null && item !== '') {
            showAlert(item);
            localStorage.setItem(MESSAGE, '');
        }
    }, [localStorage.getItem(MESSAGE)]);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themeMemo}>
                <CssBaseline />
                <Spinner area={'showProgress'} />
                <NavigationScroll>
                    <Routes />
                </NavigationScroll>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
